import axios from "axios";
import { DataResponse, PaginatedResponse } from "../models/common/responseObjects";
import { ManagedStockConflict, ManagedStockPdeApnConflict } from "models/dbModels/conflicts/ManagedStockConflict";
import { ManagedStockConflictCleanFilterQuery, ManagedStockConflictSearchFilterQuery } from "models/filters/conflicts/ManagedStockConflictSearchFilterQuery";


export class ConflictsApi {
    static managedStockConflictSearch = async (query: ManagedStockConflictSearchFilterQuery) => axios.post<PaginatedResponse<ManagedStockConflict[]>>(`api/v1/Conflicts/ManagedStockConflictSearch`, query);
    static managedStockConflictClean = async (query: ManagedStockConflictCleanFilterQuery) => axios.post<DataResponse<boolean>>(`api/v1/Conflicts/ManagedStockPdeApnDuplicateClean`, query);
}
